import styled from 'styled-components';

/* ── HERO / CAROUSEL ── */
export const TalentHero = styled.section`
  position: relative;
  width: 100%;
  height: 380px;
  overflow: hidden;
  background: #1A1A1A;
  flex-shrink: 0;

  @media (max-width: 720px) { height: 280px; }
  @media (max-width: 480px) { height: 220px; }

  .talent-swiper,
  .talent-swiper .swiper-slide {
    width: 100%;
    height: 100%;
  }

  .hero-img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    display: block;
  }

  .no-image {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #374151;
    font-size: 44px;
  }

  .hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to inline-end,
      transparent 25%,
      rgba(13, 13, 27, 0.55) 55%,
      rgba(13, 13, 27, 0.88) 100%
    );
    pointer-events: none;
  }

  .hero-content {
    position: absolute;
    bottom: 28px;
    inset-inline-start: 24px;
    max-width: 420px;
    z-index: 2;

    @media (max-width: 480px) {
      bottom: 14px;
      inset-inline-start: 14px;
      max-width: 240px;
    }

    .category-badge {
      display: inline-block;
      background: #9333EA;
      color: #fff;
      font-size: 11px;
      font-weight: 700;
      padding: 3px 14px;
      border-radius: 4px;
      margin-bottom: 10px;
      font-family: inherit;
    }

    .talent-name {
      font-size: 24px;
      font-weight: 800;
      color: #fff;
      line-height: 1.25;
      text-shadow: 0 2px 16px rgba(0, 0, 0, 0.7);
      @media (max-width: 480px) { font-size: 16px; }
    }
  }

  .talent-swiper .swiper-button-next,
  .talent-swiper .swiper-button-prev {
    width: 36px;
    height: 36px;
    background: rgba(13, 13, 27, 0.55);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 50%;
    color: #fff;
    z-index: 3;
    transition: background 0.18s, border-color 0.18s;

    &::after { font-size: 14px; font-weight: 700; }
    &:hover { background: #9236E4; border-color: #9236E4; }

    @media (max-width: 480px) { display: none; }
  }

  .talent-swiper .swiper-pagination {
    bottom: 12px;
    z-index: 3;
  }

  .talent-swiper .swiper-pagination-bullet {
    width: 7px;
    height: 7px;
    background: rgba(255, 255, 255, 0.55);
    opacity: 1;
    transition: background 0.18s, width 0.18s;
  }

  .talent-swiper .swiper-pagination-bullet-active {
    background: #9236E4;
    width: 18px;
    border-radius: 4px;
  }
`;

/* ── PAGE LAYOUT ── */
export const DetailsLayout = styled.div`
  max-width: 1100px;
  margin: 24px auto 0;
  padding: 0 24px 40px;
  display: grid;
  grid-template-columns: 1fr 280px;
  gap: 20px;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
  }
`;

export const DescriptionBox = styled.div`
  background: #1A1A1A;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 8px;
  padding: 20px 22px;

  .section-title {
    font-size: 13px;
    font-weight: 700;
    color: #e2e8f0;
    margin-bottom: 10px;
  }

  p {
    font-size: 13px;
    color: #9ca3af;
    line-height: 1.75;
    white-space: pre-wrap;
  }
`;

export const DetailsSidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .react-card {
    background: #1A1A1A;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    padding: 14px;
    display: flex;
    gap: 8px;
  }

  .react-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 38px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: #111;
    color: #9ca3af;
    font-family: inherit;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.18s;

    svg { font-size: 15px; }

    &:hover { border-color: rgba(255, 255, 255, 0.18); color: #e2e8f0; }
    &.active-like { background: rgba(22, 163, 74, 0.14); border-color: rgba(74, 222, 128, 0.3); color: #4ade80; }
    &.active-dislike { background: rgba(239, 68, 68, 0.14); border-color: rgba(248, 113, 113, 0.3); color: #f87171; }
    &.locked { cursor: not-allowed; opacity: 0.6; }
  }

  .info-card {
    background: #1A1A1A;
    border: 1px solid rgba(255,255,255,0.06);
    border-radius: 8px;
    padding: 14px 16px;

    .info-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      font-size: 12.5px;
      padding: 7px 0;
      border-bottom: 1px solid rgba(255,255,255,0.04);
      &:last-child { border-bottom: none; }

      .info-label { color: #6b7280; display: flex; align-items: center; gap: 6px; }
      .info-value { color: #e2e8f0; font-weight: 600; }
    }
  }

  .discord-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    background: #5865f2;
    color: #fff;
    text-decoration: none;
    transition: opacity 0.2s;
    width: 100%;

    &:hover { opacity: 0.85; }
  }
`;

export const BackLink = styled.div`
  max-width: 1100px;
  margin: 16px auto 0;
  padding: 0 24px;

  a {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 12.5px;
    color: #9ca3af;
    text-decoration: none;
    transition: color 0.15s;
    &:hover { color: #e2e8f0; }
  }
`;
